import { usePage } from '@inertiajs/vue3';

// Sonar S4328: @inertiajs/core is only a transitive dependency, and declaring it
// invites a second core copy; derive the Page type from the adapter's API instead.
type Page = ReturnType<typeof usePage>;

export function readInitialPage(): Page | undefined {
    if (typeof document === 'undefined') {
        return undefined;
    }

    // Inertia v3 SSR: page data lives in <script data-page="app" type="application/json">.
    // Inertia v3 non-SSR (dev): page data is a data-page attribute on #app.
    const rawPage =
        document.querySelector<HTMLScriptElement>('script[data-page="app"][type="application/json"]')?.textContent ??
        document.getElementById('app')?.dataset.page;

    if (!rawPage) {
        return undefined;
    }

    try {
        return JSON.parse(rawPage) as Page;
    } catch {
        return undefined;
    }
}

// The CDN cache key excludes click/campaign IDs, so a cached body may bake another
// visitor's IDs into its url; adopt the real location before Inertia boots, or its
// initial-visit pushState rewrites the address bar to that foreign URL.
export function getNormalizedInitialPage(): Page | undefined {
    const page = readInitialPage();

    if (!page || typeof window === 'undefined') {
        return undefined;
    }

    page.url = window.location.pathname + window.location.search;

    return page;
}
